export default {
    generateContentModal: {
        title: 'Générer du contenu',
        type: 'Type',
        typePlaceholder: 'Sélectionner le type',
        typeEmptyError: 'Veuillez sélectionner le type',
        context: 'Contexte',
        contextPlaceholder: 'Sélectionner le contexte',
        contextEmptyError: 'Veuillez sélectionner le contexte',
        contentTitle: 'Titre du contenu',
        contentTitlePlaceholder: 'Ajouter le thème de votre contenu',
        contentTitleEmptyError: 'Veuillez saisir le titre',
        contentTitleInvalidError: 'Veuillez saisir un titre valide',
        description: 'Fournir une brève description du contenu',
        descriptionPlaceholder: 'Ajoutez la description de votre contenu en 2 ou 3 lignes',
        descriptionEmptyError: 'Veuillez saisir la description',
        descriptionInvalidError: 'Veuillez saisir une description valide',
        addKeywords: 'Ajouter des mots-clés',
        addKeywordsEmptyError: 'Veuillez saisir les mots-clés',
        writingTone: "Tonalité de l'écriture",
        writingTonePlaceholder: "Sélectionner le ton de l'écriture",
        writingToneEmptyError: "Veuillez sélectionner le ton de l'écriture",
        numberOfVariations: 'Nombre de variations',
        numberOfVariationsEmptyError: 'Veuillez sélectionner le nombre de variations',
        numberOfVariationsInvalidError: 'Vous pouvez générer un maximum de 5 variations et un minimum de 1 variation.',
        generate: 'Générer',
        additionalOptions: 'Options additionnelles',
        clear: 'Effacer',
        writingToneOptions: {
            funny: 'Drôle',
            casual: 'ordinaire',
            excited: 'Enthousiaste',
            professional: 'Professionnel',
            witty: "Plein d'esprit",
            sarcastic: 'Sarcastique',
            feminine: 'Féminin',
            masculine: 'Masculin',
            bold: 'audacieux',
            dramatic: 'Dramatique',
            grumpy: 'Grincheux',
            secretive: 'Secret',
            respectful: 'Respectueux',
            persuasive: 'Persuasif',
        },
        contextOptions: {
            promotional: 'Promotionnel',
            introduction: 'Introduction',
            couponDiscount: 'Coupon/Réduction',
            recurringNewsletter: 'Newsletter récurrente',
            testimonial: 'Témoignage',
            coldOutreach: 'Contact à froid',
            contentGiveaway: 'Contenu/Concour',
            other: 'Autres',
        },
        typeOptions: {
            outline: 'Aperçu',
            introduction: 'Introduction',
            section: 'Section',
        },
    },
};
